/**
 * Déclaration d'un don par chèque ou virement avec sa preuve (justificatif), partagée par la page de parrainage et la
 * page des billets du gala. Envoie un formulaire multipart à POST /api/donations/declare du Worker : le don est créé
 * « en attente de contrôle » et le trésorier le valide après avoir comparé les informations à la preuve.
 */
window.DeclareDonation = {
    MAX_BYTES: 8 * 1024 * 1024,
    ACCEPT: 'image/*,.pdf,.heic',

    /** Sépare « 12 rue des Lilas\n34000 Montpellier » en { address, zip, city } (code postal français sur la dernière ligne). */
    splitAddress: function (text) {
        var value = String(text || '').trim();
        var match = value.match(/(?:^|[\s,;\n])(\d{5})\s+([^\n,;]+?)\s*$/);
        if (!match) return { address: value, zip: '', city: '' };
        return {
            address: value.slice(0, match.index).replace(/[\s,;]+$/, ''),
            zip: match[1],
            city: match[2].trim()
        };
    },

    /** Une adresse e-mail saisie doit être valide, même quand le champ est facultatif. */
    isValidEmail: function (value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    },

    /** Message d'erreur pour une adresse e-mail saisie mais invalide ; chaîne vide si elle est vide ou valide. */
    emailError: function (value) {
        var text = String(value || '').trim();
        if (!text || this.isValidEmail(text)) return '';
        return 'Cette adresse e-mail n\u2019est pas valide : vérifiez-la (exemple : nom@exemple.fr).';
    },

    /** Message à afficher si le fichier est inutilisable, sinon null (le Worker revérifie le contenu). */
    checkFile: function (file) {
        if (!file) return 'Joignez la preuve de votre paiement (photo, capture ou PDF).';
        if (file.size > this.MAX_BYTES) return 'Ce fichier est trop volumineux (8 Mo au maximum).';
        return null;
    },

    /** Jeton Cloudflare Turnstile si le widget est présent sur la page, sinon 'bypass' (même convention que la vérification). */
    turnstileToken: function () {
        var widget = document.querySelector('.cf-turnstile');
        var siteKey = widget ? widget.getAttribute('data-sitekey') : '';
        if (!siteKey || !siteKey.trim()) return 'bypass';
        var input = document.querySelector('.cf-turnstile [name="cf-turnstile-response"]');
        return input && input.value ? input.value : '';
    },

    /**
     * @param {{workerUrl: string, data: object, files: File[]}} options
     * @returns {Promise<{reference: string, acknowledged: boolean}>} rejette avec une Error au message lisible
     */
    submit: async function (options) {
        var token = this.turnstileToken();
        if (!token) throw new Error('Veuillez valider le Captcha.');

        var form = new FormData();
        form.set('data', JSON.stringify(options.data));
        form.set('cf_turnstile', token);
        (options.files || []).forEach(function (file) { form.append('files', file); });

        var response;
        try {
            response = await fetch(options.workerUrl + '/api/donations/declare', { method: 'POST', body: form });
        } catch (e) {
            throw new Error('Connexion impossible. Vérifiez votre connexion internet et réessayez.');
        }
        var body = null;
        try { body = await response.json(); } catch (e) { /* réponse non JSON */ }
        if (!response.ok) {
            if (window.turnstile) window.turnstile.reset();
            throw new Error((body && body.error) || 'Une erreur est survenue. Réessayez ou écrivez-nous à contact@diaspespoir.org.');
        }
        return body;
    }
};
